import React from "react";
import NotFound from "./BaseControls/NotFound";

const formcontrols = {
    // These should stay as require
    AssociationFieldlabel: require("./AssociationField/label").default,
    AssociationFieldrecordbrowser: require("./AssociationField/recordbrowser").default,
    AssociationFieldtypeahead: require("./AssociationField/typeahead").default,
    ChoiceFieldcheckbox: require("./ChoiceField/checkbox").default,
    ChoiceFielddropdown: require("./ChoiceField/dropdown").default,
    ChoiceFieldlabel: require("./ChoiceField/label").default,
    ChoiceFieldtypeahead: require("./ChoiceField/typeahead").default,
    DateFieldcalendar: require("./DateField/calendar").default,
    DateFieldlabel: require("./DateField/label").default,
    DateTimeFieldcalendar: require("./DateTimeField/calendar").default,
    DateTimeFieldlabel: require("./DateTimeField/label").default,
    DecimalFieldlabel: require("./DecimalField/label").default,
    DecimalFieldtext: require("./DecimalField/text").default,
    FileFieldlabel: require("./FileField/label").default,
    FileFieldmanager: require("./FileField/manager").default,
    IntegerFieldlabel: require("./IntegerField/label").default,
    IntegerFieldspinner: require("./IntegerField/spinner").default,
    Layoutcolumn: require("./Layout/column").default,
    Layoutcolumnset: require("./Layout/columnset").default,
    Layoutgrid: require("./Layout/grid").default,
    Layoutgridrow: require("./Layout/gridrow").default,
    Layoutgridcell: require("./Layout/gridcell").default,
    Layoutrow: require("./Layout/row").default,
    Layoutsection: require("./Layout/section").default,
    StringFielddropdown: require("./StringField/dropdown").default,
    StringFieldtext: require("./StringField/text").default,
    StringFieldtextarea: require("./StringField/textarea").default,
    StringFieldlabel: require("./StringField/label").default,
    TimeFieldspinner: require("./TimeField/spinner").default,
    TimeFieldlabel: require("./TimeField/label").default,
    Widgetbutton: require("./Widget/button").default,
    Widgetlabel: require("./Widget/label").default,
    Widgetvaluemutationbutton: require("./Widget/valuemutationbutton").default,

    /* TODO: make temporary jQuery control wrapper
    AssociationFielddevicelesiongrid: require("./AssociationField/devicelesiongrid").default,
    CompositionFieldsummarysection: require("./CompositionField/summarysection").default,
    CompositionFielddevicelesiongrid: require("./CompositionField/devicelesiongrid").default,
    Widgetmagicrootsummarysection: require("./Widget/magicrootsummarysection").default,
    */
};

/**
 * Finds a react control component based on descriptor type and control.
 *
 * @param {object} descriptor
 * @return {node}
 */
const controlResolver = (descriptor) => {
    const key = descriptor.type+descriptor.control;
    const ControlComponent = formcontrols[key];
    if(ControlComponent) {
        return ControlComponent;
    }
    // NotFound is also handling error messaging to the console.
    return NotFound;
};

export default controlResolver;

/**
 * Use descriptor control types as a standalone component without the knowledge of
 * the actual descriptor shape. Builds the descriptor for one off use.
 *
 * @param {string} type
 * @param {string} control
 * @param {object} props
 * @return {node}
 */
export const buildDescriptorControl = (type, control, props) => {
    // create a descriptor that is valid all controls.
    const descriptor = {
        control: control,
        type: type,
        key: props.shortname || props.id || "",
        id: props.id || props.key || "",
        disableBehaviour: "disable",
        label: props.label || "",
        required: !!props.required,
        config: {
            options: props.options,
            checkedValue:  props.checkedValue !== undefined ? props.checkedValue : true,
            uncheckedValue: props.uncheckedValue !== undefined ? props.uncheckedValue : false,
            granularity: props.granularity || (type === "DateField" ? "DAY" : "MINUTE"),
            multiValued: props.multiValued !== undefined ? props.multiValued : false,
            valueKey: props.valueKey || "value",
            labelKey: props.labelKey || "label",
            mode: props.mode || "client",
        },
    };

    const newProps = {
        ...props,
        value: props.value !== undefined ? props.value : null,
        enabled: props.enabled !== undefined ? props.enabled : !props.disabled,
        descriptor: descriptor,
        className: props.className || "",
        onCommitChange: (d, v) => {
            props.onCommitChange && props.onCommitChange(v);
        },
        onChange: (e, d, v) => {
            props.onChange && props.onChange(e, v); // strip off the descriptor
        },
        onFocus: (e, d, v, keyboardShortcuts) => {
            props.onFocus && props.onFocus(e, v, keyboardShortcuts); // strip off the descriptor
        },
        onBlur: (e, d, v) => {
            props.onBlur && props.onBlur(e, v); // strip off the descriptor
        },
        onKeyDown: (e, d, v) => {
            props.onKeyDown && props.onKeyDown(e, v); // strip off the descriptor
        },
        onClick: (e, d, v) => {
            props.onClick && props.onClick(e, v); // strip off the descriptor
        },
        valueType: props.valueType || "string",
        controlOnly: props.controlOnly !== undefined ? props.controlOnly : true,
        placeholder: props.placeholder !== undefined ? props.placeholder : true,
    };
    // time to get the actual descriptor control.
    const Control = controlResolver(descriptor);
    return (
        <Control {...newProps} />
    );
};
/*
buildDescriptorControl.propTypes = {
    // basic props
    id: PropTypes.string,
    key: PropTypes.string,
    controlOnly: PropTypes.bool,
    placeholder: PropTypes.bool,
    className: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    enabled: PropTypes.bool,
    disabled: PropTypes.bool,

    // action props
    onCommitChange: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,

    // input props
    valueType: PropTypes.string,

    // select/typeahead props
    multiValued: PropTypes.bool,
    options: PropTypes.array,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,

    // typeahead
    mode: PropTypes.oneOf(["client","server"]),

    // date props
    granularity: PropTypes.string,

    // checkbox props
    checkedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    uncheckedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
};
*/



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/ControlResolver.js